// @flow
import React from 'react';
import dataFormat from 'date-fns/format';
import ko from 'date-fns/locale/ko';
import Button from '../../common/Button';
import './CheckoutFailTemplate.scss';
import { numberWithCommas } from '../../../lib/common';

type Props = {
  order: any,
};

const CheckoutFailTemplate = (props: Props) => (
  <div className="CheckoutFailTemplate">
    <div className="checkout-fail">
      <h2>결제를 실패했어요</h2>

      <div className="checkout-fail-message">캐시바이 운영자에게 실시간 문의해주세요.</div>

      {/* <h3>주문 정보</h3>

      <table className="order-info">
        <tbody>
          <tr>
            <td>주문 번호</td>
            <td>
              <span className="copy-to-id">{props.order.id}</span>
              <span className="copy-to-id-button" onClick={() => {navigator.clipboard.writeText(props.order.id)}}>복사</span>
            </td>
          </tr>
          <tr>
            <td>주문 총액</td>
            <td>{numberWithCommas(props.order.total.amount.raw)}원</td>
          </tr>
          <tr>
            <td>주문 일시</td>
            <td>{dataFormat(props.order.created_at, 'YYYY년 M월 D일 HH시 mm분')}</td>
          </tr>
        </tbody>
      </table>
      <div className="checkout-fail-actions">
        <Button className="button view-more-details" to={`/orders/${props.order.id}`}>더 자세히 확인하기</Button>
      </div> */}
    </div>
  </div>
);

export default CheckoutFailTemplate;



// WEBPACK FOOTER //
// ./src/components/checkout/CheckoutFailTemplate/CheckoutFailTemplate.js